import { useParams } from "react-router-dom";
import proyectosData from "../../Data/Proyectos.json";
import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import ReactCompareImage from "react-compare-image";
import { Helmet } from "react-helmet";

const Seccion_Proyectos = () => {
    const { sCell } = useResponsive();
    const { id } = useParams();
    const proyecto = proyectosData.proyectos.find(p => p.id === parseInt(id));

    if (!proyecto) return <p>Proyecto no encontrado</p>;

    return (
        <>
            <Helmet>
                <title>{`${proyecto.titulo} | Remodelación de cocinas, baños y closets - Espacio Compacto`}</title>
                <meta
                    name="description"
                    content={proyecto.descripcion.slice(0, 155)}
                />

                {/* Open Graph */}
                <meta property="og:title" content={`${proyecto.titulo} - Espacio Compacto`} />
                <meta property="og:description" content={proyecto.descripcion.slice(0, 155)} />
                <meta property="og:image" content={proyecto.imagenes[0]} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://espaciocompato.web.app/proyectos/${proyecto.id}`} />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={`${proyecto.titulo} - Espacio Compacto`} />
                <meta name="twitter:description" content={proyecto.descripcion.slice(0, 155)} />
                <meta name="twitter:image" content={proyecto.imagenes[0]} />

                {/* JSON-LD */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CreativeWork",
                        "name": proyecto.titulo,
                        "description": proyecto.descripcion,
                        "image": proyecto.imagenes,
                        "url": `https://espaciocompato.web.app/proyectos/${proyecto.id}`,
                        "publisher": {
                            "@type": "Organization",
                            "name": "Espacio Compacto"
                        }
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'center'}
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{ maxWidth: '1400px', px: 3, pt: 15 }}
                >
                    {/* Resto de tu layout */}
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{ xs: 12, sm: 12, md: 12 }}
                    >
                        <Grid
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{ xs: 12, sm: 6, md: 7 }}
                        >
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{ xs: 12, sm: 12, md: 12 }}
                                sx={{ width: "100%", maxWidth: "600px", mx: 0 }}
                            >
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{ xs: 12, sm: 12, md: 12 }}
                                >
                                    <Typography
                                        component="h2"
                                        sx={{
                                            fontSize: sCell ? '40px' : '56px',
                                            fontWeight: 700,
                                            color: '#223B59',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {proyecto.categoria}
                                    </Typography>
                                </Grid>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{ xs: 12, sm: 12, md: 12 }}
                                >
                                    <Typography
                                        component="h2"
                                        sx={{
                                            fontSize: sCell ? '40px' : '56px',
                                            fontWeight: 700,
                                            color: '#223B59',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        {proyecto.titulo}
                                    </Typography>
                                </Grid>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'center'}
                                    sx={{ width: 'fit-content', backgroundColor: '#F5F6F7', px: 2, py: 1, mt: 4 }}
                                >
                                    <Typography
                                        component="span"
                                        sx={{ fontSize: sCell ? '14px' : '16px', fontWeight: 400, color: '#223B59', lineHeight: 1.2 }}
                                    >
                                        {proyecto.lugar}
                                    </Typography>
                                </Grid>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{ xs: 12, sm: 12, md: 12 }}
                                >
                                    <Typography
                                        component="p"
                                        sx={{ fontSize: sCell ? '16px' : '16px', fontWeight: 400, color: '#223B59', lineHeight: 1.2, pr: 15, pt: 3 }}
                                    >
                                        {proyecto.descripcion}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            justifyContent={'center'}
                            alignItems={'center'}
                            size={{ xs: 12, sm: 6, md: 5 }}
                            sx={{ pt: sCell ? 8 : 0 }}
                        >
                            <img
                                src={proyecto.imagenes[0]}
                                alt={`Imagen del proyecto ${proyecto.portada}`}
                                style={{ width: "100%", height: "auto", objectFit: "cover" }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container justifyContent="center" alignItems="center" xs={12}>
                        <Grid container spacing={0} sx={{mt: 8}}>
                            {proyecto.imagenes.map((img, index) => (
                                <Grid
                                    container
                                    size={{xs: 12, sm: 6, md: 6}}
                                    key={index}
                                    sx={{

                                        justifyContent: index % 2 === 0 ? "flex-start" : "flex-end",
                                        pb: 12,
                                    }}
                                >
                                    <img
                                        src={img}
                                        alt={`${proyecto.titulo} ${index}`}
                                        style={{width: sCell?"100%":"83%"}}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{borderTop: '1px solid #223B59', pt: 8,}}
                    >
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 7, md: 7}}
                        >
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>
                                <Typography
                                    component="h2"
                                    sx={{
                                        fontSize: sCell ? '32px' : '48px',
                                        fontWeight: 700,
                                        color: '#223B59',
                                        lineHeight: 1.2,
                                        pb: 3,
                                        pr:5
                                    }}
                                >
                                    Desliza para ver el antes y el después
                                </Typography>
                            </Grid>
                        </Grid>

                        {/* Comparador de imágenes */}
                        <Grid
                            container
                            justifyContent="center"
                            alignItems="center"
                            size={{xs: 12, sm: 5, md: 5}}
                            sx={{maxWidth: sCell?"300px":"500px", mx: "auto", pb: 5, pt:sCell?8:0}}
                        >
                            {proyecto.comparar && proyecto.comparar.length >= 2 && (
                                <ReactCompareImage
                                    leftImage={proyecto.comparar[0]}
                                    rightImage={proyecto.comparar[1]}
                                    sliderLineColor="white"
                                    sliderLineWidth={3}
                                    sliderPositionPercentage={0.5}
                                    leftImageAlt={`${proyecto.titulo} - Antes`}
                                    rightImageAlt={`${proyecto.titulo} - Después`}
                                    leftImageCss={{}}
                                    rightImageCss={{}}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Proyectos;
